import { createContext, useContext } from "react";

/**
 * True while rendering inside a Vaul drawer (e.g. MobileBookingBar). Child
 * bottom sheets use Vaul's NestedRoot so dragging them down dismisses only
 * the child and the parent drawer keeps its own drag/scale state.
 */
export const VaulDrawerNestingContext = createContext(false);
export const useInsideVaulDrawer = () => useContext(VaulDrawerNestingContext);
